<template>
  <v-container>
    <v-row>
      <v-col class="pb-0">
        <div class="is-full" style="display: inline-block">
          <h1 class="main-title">
            <span class="initial">A</span>MAZE-CpG (ver.1.0)
          </h1>
          <h2 class="sub-title">
            <span class="under-line">A</span>sia
            <span class="under-line">M</span>ethylation array
            <span class="under-line">A</span>ppri<span class="under-line"
              >z</span
            >ing for <span class="under-line">E</span>xperimental
            <span class="under-line">C</span>omparison of
            <span class="under-line">P</span>eripheral tissue &
            <span class="under-line">G</span>ray matter (Brain)
          </h2>
          <p class="text-justify mb-4">
            When studying genetics, the same genomic sequence can be obtained
            from both the peripheral and brain, but this is not the case with
            DNA methylation, a chemical modification of the genetic sequence. In
            the epigenetics in neuropsychiatric research, we essentially need to
            use brain tissue because of the tissue specificity of DNA
            methylation. However, it is a dilemma that we cannot take brain
            tissues from live humans for research<sup>1,2</sup>. Therefore,
            human neuropsychiatric epigenetics have been conducted using
            peripheral tissues such as blood, saliva, and buccal as proxy
            tissues. Still, it is unknown whether DNA methylation changes in the
            periphery reflect what is going on in the brain. Hence, the
            brain-peripheral tissue correlation databases had been developed in
            the United Kingdom<sup>3</sup>, Canada<sup>4</sup>, the United
            States<sup>5</sup> and Germany<sup>6</sup> for interpreting
            peripheral tissue methylation, but no database had been developed
            for populations of Asians. We are collecting brain tissues resected
            for the surgical treatment, together with blood, saliva, and buccal
            taken simultaneously from the same Japanese patients (meningioma,
            epilepsy, artery aneurysm, etc.), so that we can test DNA
            methylation correlation among them at specific loci. This could help
            determine which peripheral loci are most useful as markers for DNA
            methylation in the brain in Asian race for the first time.
          </p>
        </div>
      </v-col>
    </v-row>
    <v-row>
      <v-col class="pt-0 pb-5">
        <h3>Characteristics of this database</h3>
        <ul>
          <li>Developed by using samples from 19 Japanese patients</li>
          <li>Based on Infinium MethylationEPIC array (Illumina)</li>
          <li>
            The Montreal Neurological Institute (MNI) coordinates are recorded
            by the primary physician of each surgery for each resected brain
            tissue
          </li>
          <li>
            The preprocessing is exactly the same as in Reference 5, the
            original source of IMAGE-CpG (<a
              href="https://han-lab.org/methylation/default/imageCpG"
              target="_blank"
              rel="noopener noreferrer"
              >https://han-lab.org/methylation/default/imageCpG</a
            >)
          </li>
          <li>
            IMAGE-CpG mirror site (<a
              href="https://shinozaki-lab-image-cpg.web.app/"
              target="_blank"
              rel="noopener noreferrer"
              >https://shinozaki-lab-image-cpg.web.app/</a
            >)
          </li>
          <li>
            The original research article<sup>7</sup> is found here (<a
              href="https://www.nature.com/articles/s41398-023-02370-0"
              target="_blank"
              rel="noopener noreferrer"
              >https://www.nature.com/articles/s41398-023-02370-0</a
            >).
          </li>
          <li>
            The related column is here (<a
              href="https://neurosciencecommunity.nature.com/posts/development-of-the-first-asian-database-of-genome-wide-dna-methylation-correlations-between-brain-and-peripheral-tissues-of-japanese-samples"
              target="_blank"
              rel="noopener noreferrer"
              >https://neurosciencecommunity.nature.com/posts/development-of-the-first-asian-database-of-genome-wide-dna-methylation-correlations-between-brain-and-peripheral-tissues-of-japanese-samples</a
            >).
          </li>
        </ul>
      </v-col>
    </v-row>
    <v-divider></v-divider>
  </v-container>
</template>

<script>
export default {
  name: 'AMAZECpGCaption'
}
</script>

<style scoped>
.main-title {
  font-size: 24px;
}
.initial {
  font-size: 32px;
  color: #C00000;
}
.sub-title {
  margin-bottom: 16px;
  font-size: 20px;
}
.under-line {
  text-decoration: underline;
}
</style>
